import React from "react";
import LandingPageHeader from "../header/header";
import Footer from "../footer/Footer";

const Layout = ({ children }) => {
  return (
    <>
      <LandingPageHeader />
      {children}
      <Footer />
    </>
  );
};

export default Layout;
